import { ButtonGroup } from '@/shared/ui/form/ui/button-group';

import { usePaymentStore } from '../../../store';
import { PaymentDurationType } from '../../../types';

interface LoanPaymentDetailsProps {
	currentLoanOption?: {
		label: string;
		subLabel: string;
		value: PaymentDurationType;
	};
	loanOptions: {
		label: string;
		subLabel: string;
		value: PaymentDurationType;
	}[];
}

export const LoanPaymentDetails = ({
	currentLoanOption,
	loanOptions,
}: LoanPaymentDetailsProps) => {
	const { values: formValues, updateValues } = usePaymentStore();

	return (
		<>
			<div className="flex flex-col text-gray-3">
				<p>от 3 до 6 месяцев</p>
				<p>
					Месячный платеж{' '}
					<span className="font-semibold text-gray-1">
						{currentLoanOption?.subLabel.split(' ')[0]}
					</span>
				</p>
			</div>
			<div className="my-6">
				<ButtonGroup
					label="Срок рассрочки"
					name="paymentPeriod"
					value={formValues.paymentDuration}
					options={loanOptions}
					onChange={(value) =>
						updateValues({
							paymentDuration: value as PaymentDurationType,
						})
					}
				/>
			</div>
		</>
	);
};
